import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import FirstForm from "./pages/FirstForm";
import SecondForm from "./pages/SecondForm";
import { LanguageProvider } from "./context/LanguageContext";
import "flag-icons/css/flag-icons.min.css";

export default function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout><FirstForm /></Layout>} />
          <Route path="/questionario" element={<Layout><SecondForm /></Layout>} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}
